export interface EnvInfoData {
  baseUrl: string;
  /**
   * 请求接口时, 不需要判断是否登录的 白名单
   */
  authWhiteList: string[];
  /**
   * 页面进入的时候, 不需要初始化 权限的页面
   */
  withoutUser: string[];
  loginPage: string;
  env: 'dev' | 'prod';
}

const env: Record<'development' | 'production', EnvInfoData> = {
  development: {
    baseUrl: 'http://localhost',
    authWhiteList: [
      '/user/login',
      'java:/user/login',
      'java:/user/captcha',
      'java:/tenant/domain',
      '/user/logout',
      '/tenant/domain',
      '/print/data',
      '/print/task-data-free',
    ],
    withoutUser: [
      '/platform/login',
      '/platform/server-print',
      '/platform/code-gen',
      '/platform/server-print-preview',
    ],
    loginPage: '/login',
    env: 'dev',
  },
  production: {
    baseUrl: 'https://www.bpaos.com/',
    authWhiteList: [
      '/user/login',
      '/user/logout',
      'java:/user/login',
      'java:/user/captcha',
      'java:/tenant/domain',
      '/tenant/domain',
      '/print/data',
      '/print/task-data-free',
    ],
    withoutUser: [
      '/platform/login',
      '/platform/server-print',
      '/platform/code-gen',
      '/platform/server-print-preview',
    ],
    loginPage: '/login',
    env: 'prod',
  },
};

export const envInfo = () => {
  return env[process.env.NODE_ENV as 'development' | 'production'];
};
